import ReCAPTCHA from "react-google-recaptcha";

import { useMemo, useRef, useState } from "react";
import { Input } from '../../../components/Input';
import { TbKey, TbUser } from "react-icons/tb";
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form';
import { z } from 'zod'

import { ForgotPasswordLink, FormContainer, InputContainer, LoginButton, LoginButtonArea } from "./styles"
import { useAuth } from "../../../hooks/useAuth";
import { Link } from "react-router-dom";
import { isDevelopment } from "../../..";

export const LoginForm = () => {
  const [loginType, setLoginType] = useState('pf');

  const schema = useMemo(() => {
    return z
      .object({
        taxNumber: z.string().max(14, 'O campo CPF/CNPJ aceita no máximo 14 dígitos.'),
        email: z.string().optional(),
        password: z.string(),
      })
      .superRefine((data, ctx) => {
        if (loginType === 'pj-sub') {
          if (!data.email || data.email.trim() === '') {
            ctx.addIssue({
              path: ['email'],
              code: z.ZodIssueCode.custom,
              message: 'Email é obrigatório para Acesso Corporativo.',
            });
          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
            ctx.addIssue({
              path: ['email'],
              code: z.ZodIssueCode.custom,
              message: 'Email inválido.',
            });
          }
        }
      });
  }, [loginType]);

  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: zodResolver(schema),
  });

  const recaptchaRef = useRef(null);

  const { login } = useAuth();

  const handleLogin = async (data) => {
    const recaptchaToken = isDevelopment ? 'test' : recaptchaRef.current.getValue();

    await login(data.taxNumber, data.password, data.email, recaptchaToken, recaptchaRef.current, loginType);
  }

  const handleToggleLoginType = (loginType) => {
    setLoginType(loginType);
    resetField('taxNumber');
    resetField('password');
    resetField('email');
  }

  return (
    <>
      <ul className="nav nav-tabs mb-4">
        <li className="col-md-4">
          <button
            className={`nav-link ${loginType === 'pf' ? 'active fw-bold' : ''}`}
            onClick={() => handleToggleLoginType('pf')}
            style={{ color: "var(--text-primary)", cursor: "pointer" }}
          >
            Pessoa Física
          </button>
        </li>
        <li className="col-md-4">
          <button
            className={`nav-link ${loginType === 'pj' ? 'active fw-bold' : ''}`}
            onClick={() => handleToggleLoginType('pj')}
            style={{ color: "var(--text-primary)", cursor: "pointer" }}
          >
            Pessoa Jurídica
          </button>
        </li>
        <li className="col-md-4">
          <button
            className={`nav-link ${loginType === 'pj-sub' ? 'active fw-bold' : ''}`}
            onClick={() => handleToggleLoginType('pj-sub')}
            style={{ color: "var(--text-primary)", cursor: "pointer" }}
          >
            Acesso Corporativo
          </button>
        </li>
      </ul>
      <FormContainer onSubmit={handleSubmit(handleLogin)}>
        {loginType === 'pj' && (
          <>
            <InputContainer>
              <Input
                type="text"
                label="CNPJ"
                icon={<TbUser />}
                maxLength={14}
                onlyNumber
                mask={'99.999.999/9999-99'}
                register={register('taxNumber')}
                isRequired={true}
              />
              {errors.taxNumber && <span>{errors.taxNumber.message}</span>}
            </InputContainer>
            <InputContainer>
              <Input
                type="password"
                label="Senha"
                icon={<TbKey />}
                register={register('password')}
                isRequired={true}
              />
              {errors.password && <span>{errors.password.message}</span>}
            </InputContainer>
          </>
        )}
        {
          loginType === 'pf' && (
            <>
              <InputContainer>
                <Input
                  type="text"
                  label="CPF"
                  icon={<TbUser />}
                  maxLength={11}
                  onlyNumber
                  mask={'999.999.999-99'}
                  register={register('taxNumber')}
                  isRequired={true}
                />
                {errors.taxNumber && <span>{errors.taxNumber.message}</span>}
              </InputContainer>
              <InputContainer>
                <Input
                  type="password"
                  label="Senha"
                  icon={<TbKey />}
                  register={register('password')}
                  isRequired={true}
                />
                {errors.password && <span>{errors.password.message}</span>}
              </InputContainer>
            </>
          )
        }
        {loginType === 'pj-sub' && (
          <>
            <InputContainer>
              <Input
                type="text"
                label="CNPJ"
                icon={<TbUser />}
                maxLength={14}
                onlyNumber
                mask={'99.999.999/9999-99'}
                register={register('taxNumber')}
                isRequired={true}
              />
              {errors.taxNumber && <span>{errors.taxNumber.message}</span>}
            </InputContainer>
            <InputContainer>
              <Input
                type="text"
                label="Email Corporativo"
                icon={<TbUser />}
                register={register('email')}
                isRequired={true}
              />
              {errors.email && <span>{errors.email.message}</span>}
            </InputContainer>
            <InputContainer>
              <Input
                type="password"
                label="Senha"
                icon={<TbKey />}
                register={register('password')}
                isRequired={true}
              />
              {errors.password && <span>{errors.password.message}</span>}
            </InputContainer>
          </>
        )}
        {
          !isDevelopment && (
            <ReCAPTCHA
              theme={process.env.REACT_APP_COMPANY_THEME}
              className="recaptcha"
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            />
          )
        }

        {isSubmitting
          ? (
            <LoginButtonArea>
              <LoginButton type='submit' disabled>
                Acessando...
              </LoginButton>
            </LoginButtonArea>
          ) : (
            <LoginButtonArea>
              <LoginButton type='submit'>
                Acessar
              </LoginButton>

              <ForgotPasswordLink>
                <Link to={'/esqueci-senha'}>Esqueci a senha</Link>
              </ForgotPasswordLink>
            </LoginButtonArea>
          )}
      </FormContainer>
    </>
  )
}
